export default "__VITE_ASSET__M2Ik_r7Y__"